import { useEffect, useState } from "react";
import { MapPin, Users } from "lucide-react";
import { api } from "@/lib/api";

const PERIODS = [[30, "30 days"], [90, "90 days"], [0, "All time"]];

const SourceTable = ({ title, icon: Icon, rows, testid }) => (
  <div className="rounded-2xl border border-[#E7E2D6] bg-white" data-testid={testid}>
    <div className="flex items-center gap-2 border-b border-[#E7E2D6] p-3 text-sm font-semibold"><Icon className="h-4 w-4 text-[#D96B43]" />{title}</div>
    {rows.length === 0 ? <div className="p-4 text-xs text-muted-foreground" data-testid={`${testid}-empty`}>No leads in this period</div> : (
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-[11px] uppercase tracking-wider text-muted-foreground"><th className="p-3">Source</th><th className="p-3 text-right">Leads</th><th className="p-3 text-right">Members</th><th className="p-3 text-right">Customers</th><th className="p-3">Conversion</th></tr></thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.name} className="border-t border-[#F1EDE3]" data-testid={`${testid}-row-${i}`}>
                <td className="p-3 font-medium">{r.name}</td>
                <td className="p-3 text-right font-mono">{r.leads}</td>
                <td className="p-3 text-right font-mono">{r.members}</td>
                <td className="p-3 text-right font-mono font-semibold text-[#0F382C]">{r.customers}</td>
                <td className="min-w-[120px] p-3"><div className="flex items-center gap-2"><div className="h-1.5 flex-1 rounded-full bg-[#F1EDE3]"><div className="h-1.5 rounded-full bg-[#D96B43] transition-[width] duration-500" style={{ width: `${r.conversion}%` }} /></div><span className="w-11 text-right font-mono text-xs">{r.conversion}%</span></div></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
);

export const LeadSources = () => {
  const [days, setDays] = useState(90);
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/leads/sources", { params: { days } }).then((r) => setData(r.data)).catch(() => setData(null)); }, [days]);
  return (
    <div className="mb-6 space-y-3" data-testid="lead-sources">
      <div className="flex flex-wrap items-end justify-between gap-2">
        <div><div className="font-display text-lg font-semibold">Where paying customers come from</div><div className="text-xs text-muted-foreground" data-testid="lead-sources-summary">{data ? `${data.customers} paying customers from ${data.total} leads` : "Loading..."} · ranked by customers, then conversion</div></div>
        <div className="flex gap-1.5">{PERIODS.map(([d, l]) => <button key={d} onClick={() => setDays(d)} className={`rounded-full border px-3 py-1 text-xs transition-colors ${days === d ? "border-[#0F382C] bg-[#0F382C] text-white" : "border-[#E7E2D6] bg-white hover:border-[#0F382C]/40"}`} data-testid={`lead-sources-period-${d}`}>{l}</button>)}</div>
      </div>
      <div className="grid gap-3 lg:grid-cols-2">
        <SourceTable title="By area" icon={MapPin} rows={data?.areas || []} testid="lead-sources-areas" />
        <SourceTable title="By customer type" icon={Users} rows={data?.types || []} testid="lead-sources-types" />
      </div>
    </div>
  );
};
